/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const PowerBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M12.357 11.525 15.795 4.5h-5.422l-2.706 8.295h3.582l-.338 4.843 4.843-6.113h-3.397Zm5.449-1.996c.86.059 1.342.944.83 1.59l-7.886 9.952c-.658.83-2.12.369-2.05-.646l.394-5.63H6.407c-.753 0-1.295-.647-1.084-1.293L8.675 3.227c.14-.43.582-.727 1.084-.727h7.523c.815 0 1.362.747 1.035 1.415l-2.746 5.61h2.143c.03 0 .062.002.092.004Z" /></svg>);
const Power = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={PowerBase} {...rest} ref={ref} />);
export default Power;